import Cookies from 'js-cookie';

export const getAccessToken = () => {
    return Cookies.get('csrftoken');
};

export const getRefreshToken = () => {
    return Cookies.get('refreshToken');
};

export const saveTokens = (token: string, refreshToken: string) => {
    Cookies.set('csrftoken', token, { path: '/' });
    Cookies.set('refreshToken', refreshToken, { path: '/' });
};

export const isLoggedIn = (): boolean => {
    return !!getAccessToken();
};

export const logout = () => {
    Cookies.remove('csrftoken');
    Cookies.remove('refreshToken');
    Cookies.remove('isTools');
};
